(function () {
  'use strict';

  // ---- SLIDESHOW ----

  var slides = document.querySelectorAll('[data-rsi-wo-slide]');
  var dots = document.querySelectorAll('[data-rsi-wo-dot]');
  var current = 0;
  var slideshowTimer = null;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function goToSlide(index) {
    if (!slides[index]) return;
    slides[current].classList.remove('rsi-wo-slide--active');
    dots[current].classList.remove('rsi-wo-dot--active');
    dots[current].setAttribute('aria-selected', 'false');
    current = index;
    slides[current].classList.add('rsi-wo-slide--active');
    dots[current].classList.add('rsi-wo-dot--active');
    dots[current].setAttribute('aria-selected', 'true');
  }

  function startSlideshow() {
    if (prefersReducedMotion || slides.length < 2) return;
    slideshowTimer = setInterval(function () {
      goToSlide((current + 1) % slides.length);
    }, 4800);
  }

  function stopSlideshow() {
    clearInterval(slideshowTimer);
    slideshowTimer = null;
  }

  if (slides.length && dots.length) {
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopSlideshow();
        goToSlide(i);
        startSlideshow();
      });
    });

    var slideshowEl = document.querySelector('[data-rsi-wo-slideshow]');
    if (slideshowEl) {
      slideshowEl.addEventListener('mouseenter', stopSlideshow);
      slideshowEl.addEventListener('mouseleave', startSlideshow);
      slideshowEl.addEventListener('focusin', stopSlideshow);
      slideshowEl.addEventListener('focusout', startSlideshow);
    }

    startSlideshow();
  }

  // ---- MODAL ----

  var modal = document.getElementById('rsi-wo-modal');
  var openBtns = document.querySelectorAll('[data-rsi-wo-modal-open]');
  var closeBtn = document.querySelector('[data-rsi-wo-modal-close]');
  var projectInput = document.getElementById('rsi-wo-project-name');
  var continueBtn = document.getElementById('rsi-wo-modal-continue');
  var toast = document.getElementById('rsi-wo-toast');
  var lastFocused = null;

  function openModal() {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.removeAttribute('hidden');
    document.body.classList.add('rsi-wo-no-scroll');
    if (projectInput) {
      projectInput.value = '';
      projectInput.focus();
    }
    if (continueBtn) continueBtn.disabled = true;
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.classList.remove('rsi-wo-no-scroll');
    if (lastFocused) lastFocused.focus();
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', openModal);
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
      closeModal();
    }
  });

  // Enable / disable Continue button based on input
  if (projectInput && continueBtn) {
    projectInput.addEventListener('input', function () {
      continueBtn.disabled = projectInput.value.trim() === '';
    });
  }

  // Continue: save to localStorage, show toast, placeholder for route
  if (continueBtn) {
    continueBtn.addEventListener('click', function () {
      var name = projectInput ? projectInput.value.trim() : '';
      if (!name) return;

      localStorage.setItem('rsi_warehouse_optimiser_current_plan', name);

      closeModal();
      showToast('Project “' + name + '” created. The optimiser route will connect here when ready.');

      // TODO: Connect live optimiser route here when the tool is ready
      // window.location.href = '/pages/warehouse-optimiser-tool';
    });
  }

  // ---- TOAST ----

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.removeAttribute('hidden');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.setAttribute('hidden', '');
    }, 5000);
  }

})();
